import { Price } from '@model/common/currency';

export interface LuggageExtra {
  token: string;
  description: string;
  weight: string;
  price: Price;
  quantityAvailable: number;
  type: LuggageType;
}

export enum LuggageType {
  CABIN = 'cabin',
  HOLD = 'hold'
}
